import { call, put } from 'redux-saga/effects';
import { configModel } from '../app_config_model';

import {
    processOnNextActions,
    processRedirect,
    validateForm
} from './utils';

/**
 * Saga for page validation and progression
 * @param {Object} action - The action that describes the requested validation and progression.
 */
export const validateAndProgress = function* (action) {
    const isValid = yield call(validateForm, action);
    if (!isValid) {
        yield call(_setInvalidActions, action.pageName, action);
    } else {
        yield call(processOnNextActions, action, true);
        yield call(processRedirect, action, 'redirectResponse');
    }
};

/**
 * Set and dispatch the Actions for an Invalid page.
 * @param {String} pageName     - The name of the page.
 * @param {Object} action       - The action that describes the requested validation and progression.
 */
const _setInvalidActions = function* (pageName, action) {
    const models = configModel.getModels();
    const pagePath = models.pageSchemaModel.getPathForPageName(pageName);
    const pageSchema = models.pageSchemaModel.getPageSchema(pagePath);
    const invalidActions = pageSchema.invalidPageActions || [];
    for (const invalidAction of invalidActions) {
        yield put(invalidAction);
    }
    if (action.eventCB && typeof action.eventCB === 'function') {
        action.eventCB();
    }
};
